import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import { inject, observer } from 'mobx-react';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import Fade from 'react-reveal/Fade';
import ReactGA from 'react-ga';
import './AuthCreate.css';
import { setDigitalData } from '../../Utilities/Utils.js';

const theme = createMuiTheme({
    palette: {
        primary: {
            light: "#3CB6CE",
            main: "#3CB6CE",
            dark: "#3CB6CE",
            contrastText: "#3CB6CE"
        },
        text: {
            primary: "#fff" ,
            secondary: "#fff"
        },
        action: {
            active: "#fff"
        }
    },
    typography : {
        fontFamily: ['Roboto Condensed','Roboto','Helvetica'].join(','),
        fontSize: "20",
    }
});

const styles = {
    root: {
        color: "#FFF",
        '&$checked': {
            color: "#D52B1E",
        },
    },
    checked: {},
    resize:{
    },
    labelResize:{
    },
    menuItem:{
        color:'black',
    },
    underline: {
        color: theme.palette.common.white,
        borderBottom: theme.palette.common.white,
        '&:after': {
            borderBottom: `2px solid ${theme.palette.common.white}`,
        },
        '&:focused::after': {
            borderBottom: `2px solid ${theme.palette.common.white}`,
        },
        '&:before': {
            borderBottom: `1px solid ${theme.palette.common.white}`,
        },
        '&:hover:not($disabled):not($focused):not($error):before': {
            borderBottom: '2px solid rgb(255, 255, 255) !important',
        },
        '&$disabled:before': {
            borderBottom: `1px dotted ${theme.palette.common.white}`,
        },
    },
    disabled: {},
    focused: {},
    error: {}
}

class DGRAuthCreate extends Component {

    componentDidMount() {
        this.props.DGRBackgroundStore.showBlurAndHeader()
        this.props.DGRStore.errors = null;
        if ( !this.props.DGRStore.values.member_number ) {
            return this.props.history.push('');
        }
        setDigitalData( 'auth create', this.props.DGRStore.club_number );
    }

    handleChange = (e) => {
        this.props.DGRStore.setValue( e.target.name, ( ''+e.target.value ).trim() );
    }
    handleCheckboxChange = (e) => {
        this.props.DGRStore.setValue( e.target.name, e.target.checked );
    }

    handleSubmitCreateAccount = (e) => {

        ReactGA.set({ dimension7: new Date().getTime() });
        ReactGA.event({
            category: 'Member Login',
            action: 'Create Account Form'
        });

        var uppercasetest = /[A-Z]/g,
            lowercasetest = /[a-z]/g,
            numbertest = /[0-9]/g;

        // Make sure that the password match.
        if ( this.props.DGRStore.values.password !== this.props.DGRStore.values.passwordConfirm ) {
            this.props.DGRStore.errors = 'Passwords do not match.';
        } else if ( this.props.DGRStore.values.password.length > 14 || this.props.DGRStore.values.password.length < 8 ) {
            this.props.DGRStore.errors = 'Password must be 8 to 14 characters.';
        } else if ( !this.props.DGRStore.values.password.match( uppercasetest ) || !this.props.DGRStore.values.password.match( lowercasetest ) || !this.props.DGRStore.values.password.match( numbertest ) ) {
            this.props.DGRStore.errors = 'Password must contain an uppercase letter, a lowercase letter, and a number.';
        } else if ( !this.props.DGRStore.values.is_terms_accepted ) {
            this.props.DGRStore.errors = 'Please accept the Terms of Use.';
        } else if ( this.props.DGRStore.values.username.length < 6 ) {
            this.props.DGRStore.errors = 'Username must be at least 6 characters long.';
        } else {
            this.props.DGRStore.errors = '';

            var buttonText = this.refs.submitButton.innerHTML;
            this.refs.submitButton.innerHTML = 'Sending...'
            this.refs.submitButton.setAttribute( 'disabled', 'disabled' );

            // TODO: Ugly
            this.props.DGRStore.authValidateEmail().then( responseEmail => {
                if ( responseEmail && responseEmail.valid === true ) {
                    this.props.DGRStore.authValidateUsername().then( responseUsername => {
                        if ( responseUsername && responseUsername.valid === true ) {
                            this.props.DGRStore.authCreate().then( responseCreate => {
                                if ( responseCreate ) {
                                    this.props.DGRStore.authLogin().then( path => {
                                        if ( path && path.indexOf('http:') > -1 ) {
                                            window.location.href = path;
                                        } else if ( path ) {
                                            this.props.history.push( path );
                                        }
                                    });
                                } else {
                                    this.refs.submitButton.removeAttribute( 'disabled' );
                                    this.refs.submitButton.innerHTML = buttonText;
                                }
                            });
                        } else if ( responseUsername && responseUsername.valid === false ) {
                            this.props.DGRStore.errors = 'The selected username is already in use. Please select a new one.';
                            this.refs.submitButton.removeAttribute( 'disabled' );
                            this.refs.submitButton.innerHTML = buttonText;
                        } else {
                            this.refs.submitButton.removeAttribute( 'disabled' );
                            this.refs.submitButton.innerHTML = buttonText;
                        }
                    });
                } else if ( responseEmail && responseEmail.valid === false ) {
                    this.props.DGRStore.errors = 'That email is already in use. If that is your email, then try logging in with it or resetting your password.';
                    this.refs.submitButton.removeAttribute( 'disabled' );
                    this.refs.submitButton.innerHTML = buttonText;
                } else {
                    this.refs.submitButton.removeAttribute( 'disabled' );
                    this.refs.submitButton.innerHTML = buttonText;
                }
            });

        }
    }

    errorText() {
        if ( !this.props.DGRStore.errors ) {
            return null;
        }
        return (
            <div className="errorMessage">
                { this.props.DGRStore.errors }
            </div>
        );
    }

    popupInClubPrivacy = (e) => {
/*
        ReactGA.set({ dimension7: new Date().getTime() });
        ReactGA.event({
            category: 'Create Pass',
            action: 'In-Club Privacy Policy'
        });
*/
        e.preventDefault();
        e.stopPropagation();
        this.props.DGRModalStore.setURL('https://www.24hourfitness.com/membership/inclub_privacy_policy.html')
        this.props.DGRModalStore.setSection('iframe')
        this.props.DGRModalStore.setCloseVisible()
        this.props.DGRModalStore.openModal()
    }

    popupWebsitePrivacy = (e) => {
/*
        ReactGA.set({ dimension7: new Date().getTime() });
        ReactGA.event({
            category: 'Create Pass',
            action: 'Website Privacy Policy'
        });
*/
        e.preventDefault();
        e.stopPropagation();
        this.props.DGRModalStore.setURL('https://www.24hourfitness.com/company/policies/privacy/privacy_policy.html')
        this.props.DGRModalStore.setSection('iframe')
        this.props.DGRModalStore.setCloseVisible()
        this.props.DGRModalStore.openModal()
    }

    popupTerms = (e) => {
/*
        ReactGA.set({ dimension7: new Date().getTime() });
        ReactGA.event({
            category: 'Create Pass',
            action: 'SMS Terms'
        });
*/
        e.preventDefault();
        e.stopPropagation();
        this.props.DGRModalStore.setURL('https://24hourfitness.com/company/policies/terms/terms_of_use.html')
        this.props.DGRModalStore.setSection('iframe')
        this.props.DGRModalStore.setCloseVisible()
        this.props.DGRModalStore.openModal()
    }

    popupFitperks = (e) => {
/*
        ReactGA.set({ dimension7: new Date().getTime() });
        ReactGA.event({
            category: 'Create Pass',
            action: 'SMS Terms'
        });
*/
        e.preventDefault();
        e.stopPropagation();
        this.props.DGRModalStore.setURL('https://www.24hourfitness.com/fitperks/#terms')
        this.props.DGRModalStore.setSection('iframe')
        this.props.DGRModalStore.setCloseVisible()
        this.props.DGRModalStore.openModal()
    }

    render(){
        const { classes } = this.props;
        const { username, email, password, passwordConfirm, is_terms_accepted } = this.props.DGRStore.values;

        return(
            <Fade>
            <div className="authCreate">
                <MuiThemeProvider theme={theme}>

                <div className="dgrTitleText">
                    <h2>Create New Account</h2>
                </div>

                <div className="dgrTitleSubText">
                    <div className="subText">
                        Setup online access to your membership account in three easy steps.
                    </div>
                </div>

                <div className="loginItems">  
                    <ValidatorForm
                        className="authCreateForm"
                        ref="form"
                        autoComplete="off"
                        instantValidate={ false }
                        onSubmit={ this.handleSubmitCreateAccount }
                        onError={ errors => console.log(errors) }
                    >

                        <h3>Step 3: Create Login Credentials</h3>

                        <div className="row">
                            <TextValidator
                                autoComplete="off"
                                label="Username"
                                onChange={ this.handleChange }
                                name="username"
                                id="usernameField"
                                value={ username }
                                validators={['required']}
                                errorMessages={['This field is required']}
                                className="inputFieldColumn"
                                placeholder="My24 Username"
                                InputProps={{
                                    classes: {
                                        input: classes.resize,
                                        underline: classes.underline
                                    },
                                }}
                                InputLabelProps={{
                                    classes: {
                                        root: classes.labelResize,
                                    },
                                }} />

                            <TextValidator
                                autoComplete="off"
                                label="Email"
                                onChange={ this.handleChange }
                                name="email"
                                id="emailField"
                                value={ email }
                                validators={['required', 'isEmail']}
                                errorMessages={['This field is required', 'email is not valid']}
                                placeholder="eg: name@domain.com"
                                className="inputFieldColumn"
                                InputProps={{
                                    classes: {
                                        input: classes.resize,
                                        underline: classes.underline
                                    },
                                }}
                                InputLabelProps={{
                                    classes: {
                                        root: classes.labelResize,
                                    },
                                }} />

                        </div>
                        <div className="row">

                            <TextValidator
                                autoComplete="off"
                                label="Password"
                                onChange={this.handleChange}
                                name="password"
                                id="passwordField"
                                type="password"
                                value={ password }
                                validators={['required']}
                                errorMessages={['This field is required']}
                                className="inputFieldColumn"
                                placeholder="Password"
                                InputProps={{
                                    classes: {
                                        input: classes.resize,
                                        underline: classes.underline
                                    },
                                }}
                                InputLabelProps={{
                                    classes: {
                                        root: classes.labelResize,
                                    },
                                }} />
                            <TextValidator
                                autoComplete="off"
                                label="Confirm Password"
                                onChange={this.handleChange}
                                name="passwordConfirm"
                                id="passwordConfirmField"
                                type="password"
                                value={ passwordConfirm }
                                validators={['required']}
                                errorMessages={['This field is required']}
                                className="inputFieldColumn"
                                placeholder="Retype Password"
                                InputProps={{
                                    classes: {
                                        input: classes.resize,
                                        underline: classes.underline
                                    },
                                }}
                                InputLabelProps={{
                                    classes: {
                                        root: classes.labelResize,
                                    },
                                }} />

                            <div className="passwordNotes">
                                Your password must have
                                <ul>
                                    <li>8 to 14 characters</li>
                                    <li>Upper and lowercase letters (e.g. Aa)</li>
                                    <li>At least one number (e.g. 1234)</li>
                                </ul>
                            </div>

                        </div>

                        <div className="row checkboxRow">

                            <Checkbox
                                classes={{
                                    root: classes.root,
                                    checked: classes.checked,
                                }}
                                name="is_terms_accepted"
                                className="checkboxSection"
                                checked={ is_terms_accepted }
                                onChange={ this.handleCheckboxChange }
                                value={ String(is_terms_accepted) } />

                            <div className="acceptBody">
                                <span className="acceptBold">
                                    I agree to the 24hourfitness.com <a href="https://24hourfitness.com/company/policies/terms/terms_of_use.html" onClick={ this.popupTerms }>Terms of Use</a> and understand that I will be signed up for the Fit:Perks® program. <a href="https://www.24hourfitness.com/fitperks/#terms" onClick={ this.popupFitperks }>Learn more about Fit:Perks®</a>
                                </span>
                                <span className="disclaimerText">
                                    We will automatically enroll you to receive news and offers from 24 Hour Fitness upon confirmation of your account.
                                    You can change this setting at any time by clicking on the Change Preferences tab. (See also <a href="https://www.24hourfitness.com/membership/inclub_privacy_policy.html" onClick={ this.popupInClubPrivacy }>In-Club Privacy Policy</a> and <a href="https://www.24hourfitness.com/company/policies/privacy/privacy_policy.html" onClick={ this.popupWebsitePrivacy }>Website Privacy Policy</a>)
                                </span>
                            </div>

                        </div>

                        { this.errorText() }

                        <div className="row">
                            <div className="continueBtn">
                                <button ref="submitButton" className="bigButton" type="submit">Create Account</button>
                            </div>
                        </div>

                    </ValidatorForm>

                </div>
                </MuiThemeProvider>
            </div>
            </Fade>
        )
    }
}

DGRAuthCreate = inject( 'DGRBackgroundStore','DGRStore','DGRModalStore' )( observer( DGRAuthCreate ) )

export default withStyles( styles )( DGRAuthCreate );



// WEBPACK FOOTER //
// ./src/components/DGR/AuthCreate/AuthCreate.js